import joinClasses from "helpers/joinClasses";

export default function Button({ className, children, onClick, ...props }) {
  return (
    <button
      className={joinClasses(
        "rounded-xl cursor-pointer font-proximanova-extrabold tracking-[4px] md:tracking-[5px] px-10 py-3 hover:tracking-[3px] transition-all duration-200",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}
